export default {
    iPhone: /iphone/i,
};
